import DomainModel from './DomainModel'

class CaseCount extends DomainModel {
  constructor(private state: string, private totalCases: number, private casesWithInstructions: number, private cases: [] ) {
    super()
  }

  getState = () => this.state
  getCount = () => this.totalCases
  getCasesWithInstructions = () => this.casesWithInstructions
  getCaseInstruction = () => this.cases
}

export default CaseCount
